import { Component } from '@angular/core'
import {OrderDetailActionsComponent, OrderDetailsService} from '@spartacus/order/components'
import {Observable} from "rxjs";
import {EbOrderHistoryService} from "../../services/facades/eb-order-history.service";

@Component({
    selector: 'eb-order-detail-total',
    templateUrl: './eb-order-detail-total.component.html',
    standalone: false
})
export class EbOrderDetailTotalComponent extends OrderDetailActionsComponent {
  constructor(
    orderDetailsService: OrderDetailsService,
    protected ebOrderHistoryService: EbOrderHistoryService,
  ) {
    super(orderDetailsService);
    this.order$ = this.ebOrderHistoryService.getOrderDetails();
  }
}
